<template>
  <div class="header-box" @contextmenu.prevent.capture>
    <div class="head-two">
      <div class="flex-center">
        <div class="left-imgs">
          <img class="schoollogo" :src="schoolInfo&&schoolInfo.school_logo_light" @click="$router.push(`/${school_code}/zy`)" />
          <img class="szzyk-img" src="../../assets/image/elementGraph/header-szzyk.png" @click="$router.push(`/${school_code}/zy`)" />
        </div>
        <!-- 公共导航 -->
        <Navbar :target="'_blank'"></Navbar>
        <div class="login-box">
          <div v-if="appsUserInfo && appsUserInfo.name" class="login-dropdown-box">
            <div class="login-after">{{ appsUserInfo.name }}</div>
            <div class="login-sub-box">
              <template v-if="
                      appsUserInfo.user_type == 2 ||
                      (appsUserInfo.user_type == 1 && appsUserInfo.role_ids)
                    ">
                <div class="hover-item">
                  <a :href="`${services.BEIKE_SERVER}/${school_code}/sz/school/resource`" target="_blank">校内共建资源库</a>
                </div>
                <div class="hover-item">
                  <a :href="`${services.BEIKE_SERVER}/${school_code}/lesson/resource`" target="_blank">备课资源库</a>
                </div>
                <div class="hover-item">
                  <a :href="`${services.BEIKE_SERVER}/${school_code}/lesson/works`" target="_blank">协同备课</a>
                </div>
                <div class="hover-item">
                  <a :href="`${services.BEIKE_SERVER}/${school_code}/sz/favorite`" target="_blank">资源收藏</a>
                </div>
              </template>
              <template v-if="
                      appsUserInfo.user_type == 2 ||
                      (appsUserInfo.user_type == 1 && appsUserInfo.role_ids == 2)
                    ">
                <div class="hover-item">
                  <a :href="`${services.BEIKE_SERVER}/${school_code}/manage/user`" target="_blank">用户管理</a>
                </div>
              </template>
              <div class="login-lines"></div>
              <div class="hover-item">
                <a :href="`${services.APPS_WEB}/${school_code}/worker`" target="_blank">信息服务中心</a>
              </div>
              <div class="hover-item">
                <a :href="`${services.APPS_WEB}/${school_code}/userInfo`" target="_blank">个人信息设置</a>
              </div>
              <div class="hover-item">
                <a :href="`${services.APPS_WEB}/${school_code}/editPassword`" target="_blank">修改密码</a>
              </div>
              <div class="hover-item" @click="logoutEvent">
                <a href="javascript:;">退出</a>
              </div>
            </div>
          </div>
          <template v-else>
            <div class="login" @click="loginModal(true)">登 录</div>
          </template>
        </div>
      </div>
    </div>

    <!-- 登录弹层 -->
    <Login ref="loginchild"></Login>
  </div>
</template>
    
    <script>
import services from "../../assets/js/services";
import utils from "../../assets/js/utils";
import { mapState, mapActions, mapMutations } from "vuex";
import Login from "../../components/Login.vue";
import Navbar from "../../components/Navbar.vue"


export default {
  name: "Header",
  components: {
    Login,
    Navbar
  },
  data () {
    return {
      utils,
      services,
      loginSignArr: [],
      school_code: localStorage.getItem("schoolCode"),
      dialogConfig: {
        name: "",
      },
    };
  },
  computed: {
    ...mapState({
      appsUserInfo: (state) => state.appsLogin.appsUserInfo,
      loginVisible: (state) => state.appsLogin.loginVisible,
      loading: (state) => state.search.loading,
      schoolInfo: (state) => state.appsLogin.schoolInfo,
    }),
  },
  async mounted () {
    this.getAppsLoginUserInfo();
  },
  methods: {
    ...mapMutations([
      "setAppsLoginVisible",
      "setSearchSzzykData",
      "setSearchElementData",
      "resetSzzykTotal",
    ]),
    ...mapActions([
      "getAppsImageCaptcha",
      "getLoginSchoolInfo",
      "getAppsLoginUserInfo",
      "requestAppsLogout",
      "goAppsDetailsBeforeLogin",
      "schoolLoginRedirect",
    ]),

    loginModal (val) {
      let that = this;
      // 如果需要统一登录,跳转
      let param = {
        format: "json",
        school_code: that.school_code,
        from: window.location.href,
      };
      that.schoolLoginRedirect(param).then(async (res) => {
        if (
          res.code == "0000" &&
          res.data &&
          !(res.data.redirect.indexOf(services.APPS_WEB) > -1)
        ) {
          return window.open(res.data.redirect, "_self");
        } else {
          await that.setAppsLoginVisible(val);
          if (val) {
            await that.getAppsImageCaptcha();
          }
        }
      });
    },
    // 退出登录
    async logoutEvent () {
      let that = this;
      await that.requestAppsLogout().then(() => {
        if (utils.whiteList.some((item) => `/${this.school_code}${item}` == `${this.$route.path}`)) {
          that.$router.push({ path: `/${that.school_code}/` });
          that.loginModal(true);
        }
      });
    },

    ...mapActions(["goAppsDetailsBeforeLogin"]),
  },
};
    </script>
    
    <style lang="less" scoped>
.container {
    height: 100%;
}
.header-box {
    width: 100%;
    position: relative;
    z-index: 1001;
}
.head-two {
    width: 100%;
    height: 48px;
    background: linear-gradient(162deg, #dd363a 0%, #df4531 100%);
    .flex-center {
        display: flex;
        align-items: center;
        height: 100%;
        justify-content: space-between;
        padding: 0 22px 0 18px;
        .left-imgs {
            display: flex;
            align-items: center;
            .schoollogo {
                cursor: pointer;
                max-height: 34px;
                width: auto;
            }
            .split-line {
                width: 1px;
                height: 20px;
                background: #e6e3e3;
                margin: 0 20px;
                display: inline-block;
            }
            .szzyk-img {
                margin-left: 22px;
                cursor: pointer;
            }
        }
        .login-box {
            float: right;
            text-align: right;
            line-height: 30px;
            .free-trial {
                color: #fff;
                font-size: 12px;
                line-height: 30px;
                display: inline-block;
            }
            .login {
                color: #fff;
                font-size: 14px;
                display: inline-block;
                cursor: pointer;
                &::before {
                    content: '';
                    display: inline-block;
                    width: 19px;
                    height: 17px;
                    background-size: cover;
                    vertical-align: -2px;
                    background-image: url('../../assets/image/common/login.png');
                    margin-right: 8px;
                }
            }
            .register {
                color: #fff;
                font-size: 12px;
                display: inline-block;
                cursor: pointer;
                &::after {
                    content: '';
                    width: 2px;
                    height: 9px;
                    background: #eeeff0;
                    display: inline-block;
                    margin: 0 12px;
                }
            }
            .login-dropdown-box {
                height: 30px;
                position: relative;
                display: inline-block;
                .login-after {
                    color: #fff;
                    font-size: 15px;
                    // display: flex;
                    // align-items: center;
                    white-space: nowrap;
                    &::after {
                        display: inline-block;
                        content: '';
                        width: 10px;
                        height: 8px;
                        margin-left: 30px;
                        background-image: url('../../assets/image/elementGraph/up-icon.png');
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: 100% auto;
                        vertical-align: 3px;
                        transition: background-image 0.3s;
                    }
                    &::before {
                        content: '';
                        display: inline-block;
                        width: 15px;
                        height: 14px;
                        background-size: cover;
                        vertical-align: -2.5px;
                        background-image: url('../../assets/image/elementGraph/user.png');
                        margin-right: 7px;
                    }
                }
                .login-sub-box {
                    display: none;
                    position: absolute;
                    padding: 10px 20px;
                    box-sizing: border-box;
                    top: 30px;
                    left: -35px;
                    width: 140px;
                    text-align: left;
                    background-color: transparent;
                    box-shadow: 0px 1px 6px 0px rgba(130, 130, 130, 0.2);
                    border-radius: 2px;
                    transition: background-color 0.3s;
                    z-index: 1000;
                    .hover-item {
                        display: block;
                        line-height: 28px;
                        &:hover {
                            background-color: #fff;
                        }
                        a {
                            color: #393939;
                            font-size: 12px;
                            display: block;
                            &:hover {
                                color: #e64757;
                                background-color: #fff;
                            }
                        }
                    }
                    .login-lines {
                        width: 100%;
                        height: 1px;
                        background: #f3f4f5;
                        margin: 5px 0;
                    }
                }
                // &:hover .login-after::after {
                //     background-image: url('../../assets/image/common/down-icon.png');
                //     background-size: 100% auto;
                //     background-repeat: no-repeat;
                //     background-position: center;
                // }
                &:hover .login-sub-box {
                    display: block;
                    background-color: #ffffff;
                }
                &:hover .login-after::after {
                    -webkit-transform: rotate(180deg);
                    transform: rotate(180deg);
                    -webkit-transition: -webkit-transform 0.3s;
                    transition: transform 0.3s;
                }
            }
        }
    }
}

/deep/ .navbar-outer {
    width: auto;
    height: 100%;
    background: transparent;
    .navbar-inner {
        width: auto;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .nav-item {
            position: relative;
            text-align: center;
            font-weight: bold;
            font-size: 15px;
            color: #ffffff;
            opacity: 1;
            &:not(:last-child) {
                margin-right: 55px;
            }
            a,
            .link-nav {
                color: #ffffff;
                display: inline-block;
                text-decoration: none;
                cursor: pointer;
                .xxzy-list {
                    z-index: 99;
                    position: absolute;
                    display: none;
                    top: 43px;
                    left: 50%;
                    transform: translate(-50%, 10px);
                    background: #fff;
                    width: 630px;
                    border-bottom: 1px solid #ea6a59;
                    height: 95px;
                    background-size: 100%;
                    .xxzy-box {
                        margin: 14px 40px 0;
                        display: flex;
                        flex-wrap: wrap;
                        .xxzy-item {
                            width: 23%;
                            margin-top: 6px;
                            height: 24px;
                            font-size: 13px;
                            line-height: 24px;
                            font-weight: 400;
                            color: #383838;
                            background: #f8f9f9;
                            margin-left: 11px;
                            &:hover {
                                background: #fff8f3;
                                color: #dd3639;
                            }
                            &.active {
                                background: #fff8f3;
                                color: #dd3639;
                            }
                        }
                    }
                    // background: #fff;
                    &::before {
                        content: '';
                        display: block;
                        position: absolute;
                        top: -14px;
                        left: 50%;
                        transform: translateX(-50%);
                        border-top: 7px solid transparent;
                        border-left: 7px solid transparent;
                        border-bottom: 7px solid #fff;
                        border-right: 7px solid transparent;
                    }
                    &::after {
                        content: '';
                        display: block;
                        top: -12px;
                        width: 100%;
                        height: 14px;
                        position: absolute;
                        background: transparent;
                    }
                }
            }

            &.active,
            &:hover {
                font-weight: bold;
            }
            &:hover .link-nav .xxzy-list {
                display: block;
            }
            &.active .link-nav,
            &:hover .link-nav {
                color: #ffeaa0;
            }
        }
        .nav-category {
            text-align: center;
            width: 245px;
            font-size: 16px;
            font-weight: bold;
            color: #da3033;
            background-color: #ffffff;
            line-height: 42px;
            transition: all 0.3s;
        }
    }
}
.jioayu-chrome {
    font-size: 14px;
    color: #333;
    display: inline;
    line-height: 30px;
    a,
    a:hover {
        color: #df4531;
    }
    a:hover {
        text-decoration: underline;
    }
}

@media screen and (max-width: 1800px) {
    /deep/ .navbar-outer .navbar-inner .nav-item:not(:last-child) {
        margin-right: 30px;
    }
}

@media screen and (max-width: 1600px) {
    /deep/ .navbar-outer .navbar-inner .nav-item {
        font-size: 14px;
    }
    /deep/ .navbar-outer .navbar-inner .nav-item:not(:last-child) {
        margin-right: 25px;
    }
}

@media screen and (max-width: 1400px) {
    /deep/ .navbar-outer .navbar-inner .nav-item:not(:last-child) {
        margin-right: 20px;
    }
}

@media screen and (max-width: 1300px) {
    /deep/ .navbar-outer .navbar-inner .nav-item {
        font-size: 12px;
    }
    /deep/ .navbar-outer .navbar-inner .nav-item:not(:last-child) {
        margin-right: 15px;
    }
}
</style>
    